<template>
    <div class="data-load-animation" data-testid="loading-animation">
        <img
            src="/animation/data-load-animation.gif"
            alt="Data load animation"
            data-testid="loading-image"
        >
    </div>
</template>

<style scoped lang="scss">
.data-load-animation {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;

    img {
        width: 100px;
        height: 100px;
    }
}
</style>
